import React, { useEffect, useState } from 'react'
/**
 * @typedef {object} PanoramaPickerProps
 * @property {{lat: number, lng: number}} position - Posición actual del marcador en el mapa panorámico.
 * @property {function({lat: number, lng: number, pixel?: any}):void} setPosition - Función para actualizar la posición del marcador.
 * @property {{lat: number, lng: number}} [center] - Centro inicial del mapa panorámico.
 * @property {number} [heading] - Ángulo de orientación inicial de la vista panorámica.
 * @property {number} [pitch] - Ángulo de inclinación inicial de la vista panorámica.
 * @property {function(object):void} setPov - Función para actualizar el punto de vista panorámico.
 */

/**
 * Componente para seleccionar una posición y orientación en un mapa panorámico (Street View).
 * Permite arrastrar un marcador y actualizar el punto de vista (heading/pitch).
 *
 * @component
 * @example
 * const [position, setPosition] = useState({ lat: 41.94, lng: 2.31 });
 * const [pov, setPov] = useState({ heading: 0, pitch: 0 });
 * <PanoramaPicker
 *   position={position}
 *   setPosition={setPosition}
 *   setPov={setPov}
 * />
 *
 * @param {PanoramaPickerProps} props
 */
import { Panoramic } from '../../core/maps'

const CENTER_POSITION = {
  lat: 41.9405,
  lng: 2.3163,
}

const DEFAULT_POV = {
  heading: 0,
  pitch: 0,
}

export const PanoramaPicker = ({
  position,
  setPosition,
  center = CENTER_POSITION,
  heading = DEFAULT_POV.heading,
  pitch = DEFAULT_POV.pitch,
  setPov,
}) => {
  const [marker, setMarker] = useState()

  useEffect(() => {
    if (marker) {
      marker.setPosition(position)
    }
  }, [position]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Panoramic
      id="test"
      options={{
        position: center,
        pov: { heading, pitch },
        preference: 'nearest',
        zoomControl: false,
        scrollwheel: false,
        disableDoubleClickZoom: true,
      }}
      onMapLoad={(map) => {
        const gasIcon = {
          url: '/images/pipe_icon.svg',
          anchor: new window.google.maps.Point(40, 56),
          scaledSize: new window.google.maps.Size(80, 80),
        }
        const marker = new window.google.maps.Marker({
          position: position || center,
          map,
          draggable: true,
          icon: gasIcon,
        })
        setMarker(marker)
        setPosition(center)
        setPov({ ...map.pov, povLat: map.position.lat(), povLng: map.position.lng() })
        window.google.maps.event.addListener(marker, 'dragend', (e) => {
          setPosition({ lat: e.latLng.lat(), lng: e.latLng.lng(), pixel: e.pixel })
        })
        window.google.maps.event.addListener(map, 'pov_changed', () => {
          setPov({ ...map.pov, povLat: map.position.lat(), povLng: map.position.lng() })
        })
      }}
    />
  )
}

export default PanoramaPicker
